/*
 * WARNING: This file was automatically generated.
 * Changes must be made to the package.templateroot, or they will be lost!
 */
export enum IEquipmentType {
  App = 'App',
  Bike = 'Bike',
  Elliptical = 'Elliptical',
  Fusion = 'Fusion',
  InclineTrainer = 'Incline Trainer',
  Rower = 'Rower',
  Shoes = 'Shoes',
  StationaryBike = 'Stationary Bike',
  Stepper = 'Stepper',
  Strength = 'Strength',
  Strider = 'Strider',
  StudioBike = 'Studio Bike',
  Treadmill = 'Treadmill',
  TDFBike = 'TDF Bike',
  Wearable = 'wearable',
}
